import {
    getAisleTypes,
    getLedControllerAssetDetail,
    updateLedControllerAssetData,
    getLedControllerDevices
} from "../network/LEDControllerOverviewNetworkAPI";
import {chainWalk} from "../../../util/Util";

export const LEDControllerConfigurationReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DEVICES":
            return {...state, ...action.data, loadingOverview: false}
        case "LOAD_DEVICES":
            getLedControllerDevices(action.data.dispatcher)
            return state
        case "LOAD_AISLE_TYPES":
            getAisleTypes(action.data.dispatcher)
            return state
        case "RECEIVE_AISLE_TYPES":
            return {...state, ...action.data}
        case "LOAD_ASSET_DETAIL":
            getLedControllerAssetDetail(action.data.dispatcher, action.data.mac)
            return state
        case "RECEIVE_ASSET_DETAIL":
            const fetchedLedAisleData = chainWalk(() => [...action.data.aisleDetails], []);
            return {...state, ledAisleData: fetchedLedAisleData.map((aisle, index) => {return {...aisle, index: index+1}})}
        case "UPDATE_ASSET_DETAIL":
            updateLedControllerAssetData(action.data.dispatcher, action.data.mac, action.data.aisleDetails, action.data.showCustomAlert)
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/reducer/LEDControllerConfigurationReducer.js